import SingleSelectDropDownComponent from "../../CommonDropdown/SingleSelectDropdown";
import SearchBar from "../SearchBar";

/**
 * @callback InputHandler
 * @param {string} data
 * @returns {undefined}
 */
/**
 * @param {Object} props
 * @param {String} props.searchText - input value
 * @param {Object} [props.searchRef] - ref for input field
 * @param {String} props.searchPlaceholder - placeholder for input field
 * @param {String} props.dropdownSearchPlaceholder - placeholder for dropdown input field
 * @param {Boolean} props.isSearchDisabled - disabled attribute for input field
 * @param {InputHandler} props.onSearchInput - Function to process input.
 * @param {String} props.dropdownPlaceholder - Default placeholder for dropdown
 * @param {Array} props.dropdownOptions - Default options to show
 * @param {String} props.dropdownSelected - Selected option value state
 * @param {Function} props.dropdownSetSelected - State setter function for option value
 * @param {String} props.btnText - Default string to show
 * @param {OnClickEventHandler} props.onClick - What to do when click on button
 * @param {Object} [props.btnRef] - Button ref (optional) eg:- state of button ref
 * @param {String} props.txtColor - Color of text when button is enabled (var only)
 * @param {boolean} props.isBtnDisable
 * @param {boolean} props.dropdownDisabled
 * @param {String} props.btnColor - Color of bg when button is enabled (var only)

 * @returns {JSX.Element}
 */
const FilterORSearch = ({
  onSearchInput,
  searchText,
  searchRef,
  searchPlaceholder,
  isSearchDisabled,
  dropdownPlaceholder,
  dropdownOptions,
  dropdownSelected,
  dropdownSetSelected,
  dropdownDisabled,
  dropdownSearchPlaceholder,
  onClick,
  isBtnDisable,
  txtColor,
  btnColor,
  btnText,
  btnRef,
  inActiveVariantNeeded,
}) => {
  return (
    <div
      style={{
        maxWidth: "var(--max-content-width)",
      }}
      className="w-full flex gap-gap-sm flex-col Qsmd:flex-row justify-between items-center"
    >
      <div className="w-width-full Qsmd:w-width-sm">
        <SingleSelectDropDownComponent
          type="small"
          options={dropdownOptions}
          selected={dropdownSelected}
          setSelected={dropdownSetSelected}
          showSearch={true}
          searchPlaceholder={dropdownSearchPlaceholder}
          isOpen={false}
          placeholder={dropdownPlaceholder}
          disabled={dropdownDisabled}
          dropdownType={"normal"}
        />
      </div>
      <p className="text-text-secondary text-font-xs">OR</p>
      <SearchBar
        onInput={onSearchInput}
        searchText={searchText}
        searchRef={searchRef}
        placeholder={searchPlaceholder}
        isSearchDisabled={isSearchDisabled}
        onClick={onClick}
        isBtnDisable={isBtnDisable}
        txtColor={txtColor}
        btnColor={btnColor}
        btnText={btnText}
        btnRef={btnRef}
        inActiveVariantNeeded={inActiveVariantNeeded}
      />
    </div>
  );
};

export default FilterORSearch;
